export const config = {
  BASE_URL: "https://api.anyaya-events.com/",
  ANYAYA_URL: "https://www.anyaya-events.com/",
  GOOGLE_AUTH_CLIENT_ID:
    "959393559210-rdmios0qmu44c3d6mb6jap34tsknag5h.apps.googleusercontent.com",
};
